<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Coûts",
          icon: "bi bi-currency-dollar",
          route: "costs-index",
        },
        {
          label: "Nouveau coût",
          icon: "bi bi-plus-circle-fill",
          route: "costs-create",
        },
      ],
    };
  },
};
</script>
